import Vue from 'vue/dist/vue.esm.js'
Vue.component('user-report-rows-invoice-row',
  template: JST['user_report_rows/invoice_row']()
  props: ['reportRow']

  created: ->
    @updateRow = _.debounce(@updateRow, ReportRowConfig.wait)

  data: ->
    row: @reportRow
  computed:
    rowId: ->
      "row-#{@row.id}"
    expense_type: ->
      if @row.expense_type
        I18n.t("translatable_attributes.report_row.project_types.#{@row.expense_type}")

  watch:
    row:
      handler: -> @updateRow()
      deep: true

  methods:
    updateRow: ->
      $.ajax
        dataType: 'JSON',
        url: "/project_partner_report_periods/#{@row.project_partner_report_period_id}/report_rows/#{@row.id}"
        method: 'PUT'
        data: _.pick(@row, ['client_notes'])
        success: =>
          Helper.flashRow($(@$el), '#bfdf9f')
      @.$emit('update-row', @row)
)
